<blob></blob>
@if (development) {
  <dev-nav></dev-nav>
}
<router-outlet />
